import { Component, HostListener, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { AuthServiceService } from "src/app/services/auth-service.service";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
})
export class HomeComponent implements OnInit {
  loader: boolean = false;
  constructor(
    public router: Router,
    private toastr: ToastrService,
    private auth: AuthServiceService
  ) { }

  ngOnInit() {
    localStorage.setItem("proposalTabIndex", "0");
  }

  pageNavigate(data) {
    //todo: make it switch case
    if (data === "Competencies") {
      this.toastr.info("Competencies page is coming soon. Stay tuned.");
    } else if (data === "Sales") {
      this.router.navigate(["Home/searchpage"]);
    } else if (data === "Templates") {
      this.router.navigate(["Home/Templates"]);
    } else if (data === "Skills") {
      this.router.navigate(["Home/skill-repo"]);
    } else if (data === "Account") {
      this.toastr.info("Account Planning is coming soon. Stay tuned.");
    } else {
      this.router.navigate(["Home/Proposal Repository"]);
    }
  }
  isAuthorizedUser(value) {
    var roles = this.auth.getRole();

    if (roles.indexOf('SuperAdmin') >= 0 || roles.indexOf(value + '.User') >= 0 || roles.indexOf(value + '.Admin') >= 0) {
      return true;
    } else {
      return false;
    }
  }
  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent) {
    $("#sidebar_r").removeClass("active");
    $("#sidebar").removeClass("active");
    $(".overlay").removeClass("active");
  }
}
